import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnualPurchase, PurchaseSummaryReportRequest } from '../../_core/models/purchase-summary.model';
import { initialStatus, loadingStatus } from '../../../../../core/models/request-status.model';
import { BehaviorSubject, Subscription, take } from 'rxjs';
import { ReportsService } from '../../_core/reports.service';
import { Alert, ALERT_TYPE } from '../../../../../components/alert/alert.model';
import { I18nModule } from '@spartacus/core';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';
import { AlertComponent } from '../../../../../components/alert/alert.component';
import { ModalService } from '../../../../../components/modal-list/modal-list.service';
import { PurchaseSummaryDetailsComponent } from './purchase-summary-details/purchase-summary-details.component';

@Component({
  selector: 'purchase-summary',
  standalone: true,
  imports: [CommonModule, I18nModule, LocalLoaderComponent, AlertComponent],
  templateUrl: './purchase-summary.component.html',
  styleUrl: './purchase-summary.component.scss',
})
export class PurchaseSummaryComponent implements OnInit, OnDestroy {
  report$ = new BehaviorSubject<PurchaseSummaryReportRequest>(initialStatus);
  subscription = new Subscription();

  alertDanger: Alert = {
    isActive: true,
    title: '',
    content: '',
    containerClass: 'm-t-20',
    hasCloseButton: false,
    type: ALERT_TYPE.DANGER,
  };

  constructor(
    private reportsService: ReportsService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.getPricingReport();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  openAnualPurchaseModal(item: AnualPurchase) {
    this.modalService.create({
      id: 'anual-purchase-modal',
      title: 'Purchase Summary for the Period: ' + item.label + ' - (Annual Purchase)',
      width: 900,
      component: PurchaseSummaryDetailsComponent,
      data: {
        item,
      },
    });
  }

  getPricingReport() {
    this.report$.next(loadingStatus);

    this.subscription.add(
      this.reportsService
        .getPurchaseSummary()
        .pipe(take(1))
        .subscribe(_report => {
          const report: PurchaseSummaryReportRequest = {
            ..._report,
          };

          if (report.hasError) {
            this.alertDanger.content = report.message!;
          }

          this.report$.next(report);
        }),
    );
  }
}
